import { Epic } from 'interfaces/middleware'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { DELETE_ADVISOR_MEETING, deleteAdvisorMeetingActionCreator } from 'components/features/coaching/advisorStore/actions/advisorMeetingActions'
import { mergeMap } from 'rxjs/operators'
import { of, merge } from 'rxjs'
import { MEETING_URL } from 'interfaces/ajax'
import { catchAjaxSafe } from 'rxOperators/catchSafe'
import { killAllFloatingPanesActionCreator } from 'actions/floatingPanesActions'
import { deleteAjax } from 'helpers/observableAjaxHelpers'
import { GetMeetingsInfoAction } from 'components/features/coaching/advisorStore/actions/advisorPageActions'

export const deleteMeetingEpic: Epic = (action$) => action$.pipe(
  filterRequestOfType(DELETE_ADVISOR_MEETING, 'request'),
  mergeMap(({ payload }) => {
    const { params } = payload

    return deleteAjax({ url: MEETING_URL, params: { uid: params.uid }}).pipe(
      mergeMap(() => merge(
        of(new GetMeetingsInfoAction()),
        of(deleteAdvisorMeetingActionCreator.success(params, {})),
        of(killAllFloatingPanesActionCreator()),
      )),
      catchAjaxSafe((error) => merge(
        of(deleteAdvisorMeetingActionCreator.fail(params, error.status, error.xhr.response)),
      ))
    )
  }),
)
